import { NgrxValueConverter } from 'ngrx-forms';

export const CustomNgrxValueConverters = {
  dateOnlyToISOString: {
    convertViewToStateValue: (date) => {
      if (date === null) {
        return null;
      }
      const dateWithoutOffset = getDateTimeWithoutTimeOffset(date);
      return dateWithoutOffset.toISOString();
    },
    convertStateToViewValue: (s) =>
      s === null ? null : new Date(Date.parse(s)),
  } as NgrxValueConverter<Date | null, string | null>,
};

export function getCurrentDateTimeString() {
  const now = new Date();
  return `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
}

export function getDateTimeWithoutTimeOffset(value: Date) {
  const getUTC = value.getTime();
  const offset = value.getTimezoneOffset() * 60000;
  return new Date(getUTC - offset);
}

export function getOnlyDateIsoFormat(value: Date) {
  const year = value.getFullYear();
  const month = (value.getMonth() + 1).toString().padStart(2, '0');
  const day = value.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseDate(dateString: string): Date {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
}
